export type { CustomRequestTimestamp, GatewayError } from '@/shared/api/client'
export {
  apiInstance,
  getGatewayErrorCode,
  getGatewayErrorMessage
} from '@/shared/api/client'
export { default } from '@/shared/api/client'
